<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3"  >
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Training & Certification</a>
      </li>
      
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
              Training & Certification Overview
            </li>
            <li class="filter-sort">
              <div class="filter-sort-wrapper" (clickOutside)="onClickedOutside()">
                <a class="settings" data-toggle="collapse" data-target="#filter" (click)="onTabOpen()">
                  <i class="fa fa-filter" aria-hidden="true" pTooltip="Filter" tooltipPosition="top"></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li>
                      <div class="leave-type">
                        <h5 class="margin-bottom-10">Unit </h5>
                        <p-multiSelect [options]="unitList" [(ngModel)]="selectedUnit"></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5 class="margin-bottom-10">Users </h5>
                        <p-multiSelect [options]="allUsersData" [(ngModel)]="selectedUserId"></p-multiSelect>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="leave-type">
                        <h5 class="margin-bottom-10">Training Title </h5>
                        <p-multiSelect [options]="TrainingTitles" [(ngModel)]="selectedTraining"></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5 class="margin-bottom-10">Training Status </h5>
                        <p-multiSelect [options]="status" [(ngModel)]="selectedStatus"></p-multiSelect>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="leave-type">
                        <h5>Planned Date </h5>
                        <div class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10">
                          <div class="col-lg-6 col-md-6 col-sm-6 no-padding-left">
                            <p-calendar [showIcon]="true" [maxDate]="currentDate" [showTime]="true" placeholder="From"
                              dateFormat="dd/mm/yy" [(ngModel)]="tncFromDate" class="custom-datepicker"
                              readonlyInput="true" #timeOfUse="ngModel" monthNavigator="true" yearNavigator="true"
                              yearRange="1950:2100" showButtonBar="true"></p-calendar>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 no-padding-right">
                            <p-calendar [showIcon]="true" [minDate]="tncFromDate" [maxDate]="currentDate"
                              dateFormat="dd/mm/yy" [showTime]="true" placeholder="To" [(ngModel)]="tncToDate"
                              class="custom-datepicker" readonlyInput="true" #timeOfUse="ngModel" monthNavigator="true"
                              yearNavigator="true" yearRange="1950:2100" showButtonBar="true">
                            </p-calendar>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a (click)="resetFilter()" role="button" class="btn btn-primary primary-btn button-reset">
                          <i class="fa fa-refresh"></i>Reset

                        </a>
                        <a (click)="doneFilter()" role="button" class="btn btn-primary primary-btn button-submit">
                          <i class="fa fa-check"></i>Done
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
                <a class="settings" data-toggle="collapse" data-target="#sort" (click)="onTabOpen()">
                  <i class="fa fa-sort" aria-hidden="true" pTooltip="Sort" tooltipPosition="top"></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul class="filter-section-wrapper sort-section-wrapper collapse" id="sort">
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>TNC Id</label>
                          <a class="">
                            <i (click)="ascCourseId()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
                          </a>
                          <a>
                          </a>
                          <a class="selected">
                            <i (click)="descCourseId()" class="fa fa-long-arrow-down" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>Planned Date From</label>
                          <a class="">
                            <i (click)="ascPlannedDate()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
                          </a>
                          <a>
                          </a>
                          <a class="selected">
                            <i (click)="descPlannedDate()" class="fa fa-long-arrow-down" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="no-margin-right">
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>Name</label>
                          <a class="">
                            <i (click)="ascName()" class="fa fa-long-arrow-up" aria-hidden="true"></i>
                          </a>
                          <a>
                          </a>
                          <a class="selected">
                            <i (click)="descName()" class="fa fa-long-arrow-down" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10">
              <a [ngClass]="tncRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
                (click)="tncRecords.length ? exportToExcel() : $event.preventDefault()"
                class="btn btn-primary primary-btn button-excel" role="button">
                <i class="fa fa-file-excel-o" style="padding-right:10px"></i>
                <ng-container>Export To Excel</ng-container>
              </a>
              <a [ngClass]="tncRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
                (click)="tncRecords.length ? downloadZIP() : $event.preventDefault()"
                class="btn btn-primary primary-btn button-zip" role="button">
                <i class="fa fa-file-zip-o" style="padding-right:10px"></i>
                <ng-container>Export To ZIP</ng-container>
              </a>
              <a [ngClass]="tncRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
                (click)="tncRecords.length ? exportToTrainingMatrixExcel() : $event.preventDefault()"
                class="btn btn-primary primary-btn button-matrix" role="button">
                <i class="fa fa-file-zip-o" style="padding-right:10px"></i>
                <ng-container>Export Training Matrix</ng-container>
              </a>
            </div>
            <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right">
              <input type="text" placeholder="Search" class="form-control search-obs" [(ngModel)]="searchText"
                (keyup.enter)="searchData()" />
              <button class="btn btn-primary primary-btn">
                <i class="fa fa-search search" (click)="searchData()" [class.padding]="searchText.length>0"></i>
                <i class="fa fa-close clear" *ngIf="searchText.length>0" (click)="clearSearch()"></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15">
            <table align="center" class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th style="width: 20px" rowspan="2">
                    <input type="checkbox" [checked]="isTnCChecked"
                      (change)="selectAllTnCRequests($event.target.checked)" [(ngModel)]="isTnCChecked"
                      [value]="isTnCChecked">
                  </th>
                  <th style="width: 50px" rowspan="2">ID</th>
                  <th style="width: 50px" rowspan="2">Unit</th>
                  <th style="width: 90px" rowspan="2">Name of Employee</th>
                  <th style="width: 80px" rowspan="2">Designation</th>
                  <th style="width: 90px" rowspan="2">Reporting To</th>
                  <th style="width: 200px" rowspan="2">Training Title</th>
                  <th style="width: 140px" rowspan="1" colspan="2" class="center custom-border">Planned Date</th>
                  <th style="width: 80px" rowspan="2">Training Status</th>
                  <th style="width: 80px" rowspan="2">Expiry Date</th>
                  <th style="width: 20px" rowspan="2">User Profile</th>
                  <th style="width: 20px" rowspan="2">Preview</th>
                  <th style="width: 20px" rowspan="2">Download</th>
                  <th style="width: 20px" rowspan="2" *ngIf="independentPermissions.SUPER_Admin" >Action</th>
 
                </tr>
                <tr>
                  <th style="width: 70px" rowspan="2">From</th>
                  <th style="width: 70px" rowspan="2">To</th>
                </tr>
              </thead>
              <tbody>
                <tr (contextmenu)="cm.show($event);showContextMenu(tncRecord)" #row style="cursor:pointer;"
                  *ngFor='let tncRecord of tncRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'>
                  <td>
                    <span *ngIf="tncRecord.StatusName ==='Draft'">
                      <input type="checkbox" [disabled]="tncRecord.StatusName==='Draft'"
                      (change)="selectTncRequests(tncRecord,$event)" [value]="tncRecord">
                    </span>
                    <span *ngIf="tncRecord.StatusName !=='Draft'">
                      <input type="checkbox" [(ngModel)]="tncRecord.Checked" [checked]="tncRecord.Checked"
                      (change)="selectTncRequests(tncRecord,$event)" [value]="tncRecord">
                    </span>
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    <span *ngIf="tncRecord.StatusName ==='Draft'" style="color:red">Draft</span>
                    <span *ngIf="tncRecord.StatusName !=='Draft'">{{"TNC"+tncRecord.CourseId}}</span>	
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.UnitName}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.NameOfEmployee}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.Designation}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.ReportingTo}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.ParticularName}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.DurationFrom | dateTimeFormat: "MMM D, YYYY"}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.DurationTo | dateTimeFormat: "MMM D, YYYY"}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    {{tncRecord.StatusName}}
                  </td>
                  <td (click)="getCurrentDOMElementId(tncRecord.CourseId)"
                    [routerLink]="['/tnc/assign-training/', tncRecord.CourseId,{unitId :tncRecord.UnitId}]">
                    <ng-container *ngIf="tncRecord.ExpiryDate && tncRecord.Validity !='Lifetime' && tncRecord.StatusName != 'Pending for Approval' && tncRecord.StatusName != 'Rejected' && tncRecord.StatusName != 'In Progress'">
                      {{tncRecord.ExpiryDate | dateTimeFormat: "MMM D, YYYY"}}
                    </ng-container>
                    <ng-container *ngIf="tncRecord.Validity =='Lifetime'">
                      Lifetime
                    </ng-container>
                    <ng-container *ngIf="!tncRecord.ExpiryDate && tncRecord.Validity !='Lifetime'">
                      NA
                    </ng-container>
                    <ng-container *ngIf="tncRecord.ExpiryDate && tncRecord.Validity !='Lifetime' && (tncRecord.StatusName == 'Pending for Approval' || tncRecord.StatusName == 'Rejected' || tncRecord.StatusName == 'In Progress')">
                      NA
                    </ng-container>
                  </td>
                  <td>
                    <button role="button" class="btn btn-primary primary-btn button-view"
                      [routerLink]="['/tnc/user-profile/', tncRecord.UserId]">
                      View</button>
                  </td>
                  <td>
                    <div *ngIf="tncRecord.Certificate && tncRecord.Certificate.length > 0">
                      <ara-files-previewer [files]="tncRecord.Certificate"></ara-files-previewer>
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <i (click)="downloadPDF(tncRecord.CourseId)" class="fa fa-download"></i>
                  </td>

                  <td *ngIf="independentPermissions.SUPER_Admin">
                    <ara-record-actions *ngIf="tncRecord.StatusName === 'Deleted'" [SourceId]="tncRecord.CourseId" ModuleName="TNC" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >
                    </ara-record-actions>
                   </td>
                </tr>
              </tbody>
            </table>
            <div style="width: 500px;margin-top:15px;color: red" *ngIf="(tncRecords.length == 0)">
              No Records Found
            </div>

            <div style="width: 500px" *ngIf="(tncRecords.length > 1)">
              <pagination-controls (pageChange)="getServerData($event)"></pagination-controls>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<p-contextMenu [appendTo]="row" [target]="row" #cm [model]="contextItems"></p-contextMenu>
